import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import AuctionsPage from 'containers/Auctions';
import CasinoversePage from 'containers/CasinoversePage';
import DrawingsPage from 'containers/Drawings';
import ErrorBoundary from 'containers/ErrorBoundary';
import Feed from 'containers/Feed';
import { selectShowFeed } from 'containers/Feed/selectors';
import GameSlotsPage from 'containers/GameSlotsPage';
import HomeIconsView from 'containers/HomePage/HomeIconsView';
import QuestsPage from 'containers/QuestsPage';
import TournamentListPage from 'containers/TournamentListPage';
import VideoFeed from 'containers/VideoFeed';
import WStorePage from 'containers/WStorePage';
import ActiveUsersDisplay from 'components/ActiveUsersDisplay';
// import FeedbackBanner from 'components/FeedbackBanner';
import HomeIconExit from 'components/HomeExitIcon';
import {
  CV_WEB_HOMELAYOUTUPDATE_ENABLED,
  CV_WEB_ONLINE_USERS_UI_ENABLED,
  MD_BREAKPOINT_AND_UP
} from 'utils/constants';
import { QUERY_GET_REMOTE_CONFIG_ENTRY } from 'utils/hook/query/useRemoteConfigEntry';
import useMediaQuery from 'utils/useMediaQuery';
import PlayAndEarn from './SectionRows/Banner/PlayAndEarn';
import RewardsAwait from './SectionRows/Banner/RewardsAwait';
import VisitBanner from './SectionRows/Banner/VisitBanner';
import CarouselBanner from './SectionRows/CarouselBanner';
// import Dashboard from './SectionRows/Dashboard';
import GetTheApp from './SectionRows/GetTheApp';
import ReferFriend from './SectionRows/ReferFriend';
import TrendingNow from './SectionRows/TrendingNow';
// import WStoreRewards from './SectionRows/WStoreRewards';
import WinningMoment from './SectionRows/WinningMoment';
import './HomePage.css';

function HomePage({
  location,
  showFeed,
  data,
  subscribeToNewData,
  onlineUsersRemoteConfig
}) {
  useEffect(() => {
    let unsubscribeFromNewData = subscribeToNewData();

    return () => {
      unsubscribeFromNewData();
      unsubscribeFromNewData = () => {};
    };
  }, [subscribeToNewData]);

  const isHomePage = location.pathname === '/';
  const isTabletOrLarger = useMediaQuery(MD_BREAKPOINT_AND_UP);
  const shouldDisplayFeed = isTabletOrLarger || showFeed;
  const shouldDisplayPageIcons =
    isTabletOrLarger || (!shouldDisplayFeed && !isTabletOrLarger);
  const cmClass = `community-message-wrapper ${!isHomePage ? 'fade-out' : ''}`;
  const pgLeftPanelClass = `page-left-panel ${!isHomePage ? 'fade-out' : ''}`;
  const homeRowsClass = `home-icons ${!isHomePage ? 'fade-out' : ''}`;
  const exitIconClass = `home-icons-exit-icon ${
    !!isHomePage ? 'exit-fade-icon' : ''
  }`;
  const oldLayoutClass = `old-layout ${!isHomePage ? 'fade-out' : ''}`;
  // const feedbackBannerClass = !isHomePage ? 'fade-out' : '';

  const { loading, remoteConfigEntry } = data || {};
  const { key, value } = remoteConfigEntry || {};
  const homeLayoutUpdateEnabled =
    !loading && key === CV_WEB_HOMELAYOUTUPDATE_ENABLED && value;
  const onlineUsersDisplayEnabled =
    !onlineUsersRemoteConfig?.loading &&
    onlineUsersRemoteConfig?.remoteConfigEntry?.value;

  const bannerList = [
    {
      title: 'rewards-await',
      Element: RewardsAwait
    },
    {
      title: 'play-and-earn',
      Element: PlayAndEarn
    },
    {
      title: 'visit-us-banner',
      Element: VisitBanner
    }
  ];

  return (
    <div className={`page-container home-page`}>
      <h1 className="sr-only">Wind Creek Casino Home</h1>
      {shouldDisplayPageIcons && (
        <div className={pgLeftPanelClass}>
          {homeLayoutUpdateEnabled ? (
            <>
              <div className={homeRowsClass}>
                <CarouselBanner bannerList={bannerList} />
                <ErrorBoundary>
                  <HomeIconsView
                    location={location}
                    homeLayoutUpdateEnabled={homeLayoutUpdateEnabled}
                  />
                </ErrorBoundary>
                <TrendingNow />
                <WinningMoment />
                <div className="more-info">
                  <GetTheApp />
                  <ReferFriend />
                </div>
              </div>
              <HomeIconExit url="/" className={exitIconClass} />
            </>
          ) : (
            <>
              <div className={oldLayoutClass}>
                <div className={cmClass}>
                  Play today and Find Your Winning Moment!
                </div>
                {/* <FeedbackBanner classSuffix={feedbackBannerClass} /> */}
              </div>
              <ErrorBoundary>
                <HomeIconsView location={location} />
              </ErrorBoundary>
            </>
          )}

          <ErrorBoundary>
            <Switch>
              <Route exact path="/auctions" component={AuctionsPage} />
              <Route
                exact
                path="/about-casinoverse"
                component={CasinoversePage}
              />
              <Route exact path="/slots" component={GameSlotsPage} />
              <Route exact strict path="/drawings" component={DrawingsPage} />
              <Redirect from="/drawings/" to="/drawings" />
              <Route exact path="/videos" component={VideoFeed} />
              <Route exact path="/wstore" component={WStorePage} />
              <Route exact path="/tournaments" component={TournamentListPage} />
              <Route exact path="/quests" component={QuestsPage} />

              <Route exact path="/" />
              <Redirect to="/" key="not-found-redirect" />
            </Switch>
          </ErrorBoundary>
        </div>
      )}
      {/* TEMP: Enable below when Sapphires section addes to Home.  Also, re-enable '&.update-home-layout in Feed.scss */}
      {/* {!shouldDisplayFeed && homeLayoutUpdateEnabled && (
        <ErrorBoundary>
          <Dashboard homeLayoutUpdateEnabled={homeLayoutUpdateEnabled} />
        </ErrorBoundary>
      )} */}
      {shouldDisplayFeed && (
        <div
          className={`page-right-panel ${
            !onlineUsersDisplayEnabled ? 'full-panel-view' : ''
          }`}
        >
          {/* TEMP: Enable below when Sapphires section addes to Home.  Also, re-enable '&.update-home-layout in Feed.scss */}
          {/* {homeLayoutUpdateEnabled && (
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          )} */}
          <ErrorBoundary>
            <h2 className="sr-only">Community Wall</h2>
            <Feed homeLayoutUpdateEnabled={homeLayoutUpdateEnabled} />
          </ErrorBoundary>
          {onlineUsersDisplayEnabled && (
            <ErrorBoundary>
              <h2 className="sr-only">Online Users</h2>
              <ActiveUsersDisplay />
            </ErrorBoundary>
          )}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  showFeed: selectShowFeed()
});

const withConnect = connect(mapStateToProps, null);

const REMOTE_CONFIG_EVENT = gql`
  subscription remoteConfigEvent {
    remoteConfigEvent {
      action
      entries {
        key
        value
      }
    }
  }
`;

export default compose(
  graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
    options: {
      variables: {
        key: CV_WEB_HOMELAYOUTUPDATE_ENABLED
      },
      fetchPolicy: 'cache-and-network'
    },
    props: ({ data }) => {
      return {
        data,
        subscribeToNewData: () => {
          return data.subscribeToMore({
            document: REMOTE_CONFIG_EVENT,
            updateQuery: (prev, { subscriptionData }) => {
              if (subscriptionData?.data?.action === 'Update') {
                subscriptionData?.data?.entries.forEach(({ key, value }) => {
                  if (key === CV_WEB_HOMELAYOUTUPDATE_ENABLED) {
                    prev.remoteConfigEntry.value = value;
                  }
                });
              }
              return prev;
            }
          });
        }
      };
    }
  }),
  graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
    name: 'onlineUsersRemoteConfig',
    options: {
      variables: {
        key: CV_WEB_ONLINE_USERS_UI_ENABLED
      },
      fetchPolicy: 'cache-and-network'
    },
    props: ({ onlineUsersRemoteConfig }) => {
      return {
        onlineUsersRemoteConfig,
        subscribeToNewData: () => {
          return onlineUsersRemoteConfig.subscribeToMore({
            document: REMOTE_CONFIG_EVENT,
            updateQuery: (prev, { subscriptionData }) => {
              if (
                subscriptionData?.onlineUsersRemoteConfig?.action === 'Update'
              ) {
                subscriptionData?.onlineUsersRemoteConfig?.entries.forEach(
                  ({ key, value }) => {
                    if (key === CV_WEB_ONLINE_USERS_UI_ENABLED) {
                      prev.remoteConfigEntry.value = value;
                    }
                  }
                );
              }
              return prev;
            }
          });
        }
      };
    }
  }),
  withConnect
)(HomePage);
